import { apiClient } from '../client';
import type { AdvisorTools } from '@aaimplatform/institutional-types';
import type { AdminPortalBff } from '@aaimplatform/institutional-types';

export type Loan = AdvisorTools.components['schemas']['Loan'];
export type LoanListResponse = AdminPortalBff.components['schemas']['LoanListResponse'];
/** 200 body of POST /admin/loans/approve and /admin/loans/archive (admin-portal-bff.openapi.yaml). */
export type BulkLoanActionResponse = AdminPortalBff.components['schemas']['BulkLoanActionResponse'];
/**
 * 409 body of POST /admin/loans/archive: the requested loans that may not
 * close, each with its reason; no loan was changed. archive() rejects with the
 * client's ApiError, whose `data` carries this body.
 */
export type LoanArchiveRefusal = AdminPortalBff.components['schemas']['LoanArchiveRefusal'];
export const loansApi = {
  list: async (params?: {
    status?: string;
    collateralType?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<LoanListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.set('status', params.status);
    if (params?.collateralType) queryParams.set('collateralType', params.collateralType);
    if (params?.search) queryParams.set('search', params.search);
    if (params?.page) queryParams.set('page', String(params.page));
    if (params?.limit) queryParams.set('limit', String(params.limit));
    const query = queryParams.toString();
    return apiClient.get<LoanListResponse>(`/admin/loans/active${query ? `?${query}` : ''}`);
  },

  approve: async (ids: string[]): Promise<BulkLoanActionResponse> => {
    return apiClient.post<BulkLoanActionResponse>('/admin/loans/approve', { ids });
  },

  archive: async (ids: string[]): Promise<BulkLoanActionResponse> => {
    return apiClient.post<BulkLoanActionResponse>('/admin/loans/archive', { ids });
  },
};
